module.exports = __webpack_public_path__ + "static/ripple-ventures-logo-42b485adf07e032632d31cf377bcdd9c.svg";